export default __webpack_public_path__ + "static/media/Money-Foll-2-1.470d4c6a.png";